import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SeoulChurchPage.css';

function SeoulChurchPage() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/seoul-church';
  };

  return (
    <div className="seoul-church-wrap">
      <header className="seoul-church-header">
        <div className="header-inner">
          <div className="user-menu">
            {user ? (
              <>
                <span className="user-name">{user.nick_name}님</span>
                <button onClick={handleLogout} className="auth-link">로그아웃</button>
              </>
            ) : (
              <>
                <Link to="/login" className="auth-link">로그인</Link>
                <Link to="/signup" className="auth-link">회원가입</Link>
              </>
            )}
          </div>
          <div className="logo-top">
            <Link to="/seoul-church" className="logo-main">
              <img src="/sustlogo.png" alt="서울샘터교회" />
            </Link>
          </div>
          <div className="nav-row">
            <Link to="/" className="logo-sub" title="다비아 메인으로 이동">
              <img src="/images/dasaem-logo.jpg" alt="대구성서아카데미" />
            </Link>
            <nav>
              <Link to="/">다비아 홈</Link>
              <Link to="/seoul-church">교회소개</Link>
              <Link to="/seoul-church/news">교회소식</Link>
              <Link to="/seoul-church/committee">운영위원회</Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="seoul-church-main">
        <div className="content-wrap">
          <h1>교회소개</h1>

          <section className="intro">
            <h2>서울 샘터교회는</h2>
            <p>
              서울샘터교회는 대구성서아카데미와 함께 성서에 대한 깊이 있는 이해와 생명의 복음을 추구하며,
              하나님의 말씀이 우리 삶 가운데 구체적으로 실현되도록 힘쓰는 공동체입니다.
            </p>
            <p>
              우리는 단순히 교회 성장이나 외형적인 활동에 치우치지 않고, 성서와
              2천년 교회 역사를 토대로 기독교 신앙의 본질을 탐구합니다. 맹목적인
              신앙에 빠지지 않을 뿐만 아니라 시대정신에 함몰되지도 않는, 종말론적
              희망을 품고 역사 변혁에 참여하고자 하는 모든 분들을 환영합니다.
            </p>
          </section>

          <section className="worship">
            <h2>예배안내</h2>
            <div className="worship-grid">
              <div className="worship-card">
                <h3>현장 예배</h3>
                <ul>
                  <li><span>주일 예배</span><strong>오전 11:00</strong></li>
                  <li><span>수요 기도회</span><strong>오후 7:30</strong></li>
                </ul>
              </div>
              <div className="worship-card">
                <h3>온라인 예배</h3>
                <ul>
                  <li>
                    <span>유튜브</span>
                    <a href="https://www.youtube.com/@정용섭-g9s" target="_blank" rel="noopener noreferrer">
                      채널 바로가기
                    </a>
                  </li>
                  <li>
                    <span>설교링크</span>
                    <a href="https://indiadabia.blogspot.com/" target="_blank" rel="noopener noreferrer">
                      블로그 바로가기
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="pastor">
            <h2>담임목사 소개</h2>
            <div className="pastor-info">
              <h3>정용섭 목사</h3>
              <p className="pastor-position">서울샘터교회 담임목사 / 대구성서아카데미 원장</p>

              <div className="pastor-details">
                <div>
                  <h4>학력</h4>
                  <ul>
                    <li>서울신학대학교 졸업</li>
                    <li>서울신학대학교 대학원 석사 (한스 큉의 교회론)</li>
                    <li>독일 쾰른 대학교, 뮌스터 대학교 수학 (1983-1985)</li>
                    <li>계명대학교 대학원 신학박사 (판넨베르크의 계시론, 1993)</li>
                  </ul>
                </div>

                <div>
                  <h4>주요 경력</h4>
                  <ul>
                    <li>군목 역임 (1980-1983)</li>
                    <li>현풍제일교회 개척 및 담임 (1986-1997, 11년 6개월)</li>
                    <li>영천성결교회 담임 (1998-2000)</li>
                    <li>샘터교회 개척 및 담임 (2003년 6월 ~ 현재)</li>
                    <li>영남신학대학교 출강</li>
                  </ul>
                </div>

                <div>
                  <h4>주요 저서</h4>
                  <ul>
                    <li>『설교란 무엇인가』 (홍성사, 2011)</li>
                    <li>『주기도란 무엇인가』 (홍성사, 2011)</li>
                    <li>『설교비평집 1, 2, 3』 (기독교서회)</li>
                    <li>『기독교가 뭐꼬?』 (다비아책, 2009)</li>
                    <li>『매일 기도하라』 (한들출판사, 2013) 외 다수</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="location">
            <h2>오시는 길</h2>
            <div className="location-grid">
              <div className="contact-info">
                <dl>
                  <dt>주소</dt>
                  <dd>서울특별시 (상세 주소는 교회로 문의해주세요)</dd>
                </dl>
                <dl>
                  <dt>전화</dt>
                  <dd>교회로 문의해주세요</dd>
                </dl>
                <dl>
                  <dt>이메일</dt>
                  <dd><a href="mailto:freude103801@hanmail.net">freude103801@hanmail.net</a></dd>
                </dl>
                <dl>
                  <dt>웹사이트</dt>
                  <dd><a href="http://seoulsaem.org" target="_blank" rel="noopener noreferrer">seoulsaem.org</a></dd>
                </dl>
              </div>
              <div className="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.5!2d126.98!3d37.57!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDM0JzAwLjAiTiAxMjbCsDU4JzAwLjAiRQ!5e0!3m2!1sko!2skr!4v1234567890"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="서울샘터교회 위치"
                ></iframe>
              </div>
            </div>
          </section>
        </div>
      </main>

      <footer className="seoul-church-footer">
        <div className="footer-links">
          <a href="http://dabia.net" target="_blank" rel="noopener noreferrer">대구성서아카데미</a>
          <a href="/church">다비아샘터교회</a>
          <a href="https://indiadabia.blogspot.com/" target="_blank" rel="noopener noreferrer">설교링크</a>
        </div>
        <button className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          ↑
        </button>
      </footer>
    </div>
  );
}

export default SeoulChurchPage;
